import React, { useContext, useEffect, useState } from "react";
import { useAuthContext } from "../../../../contexts/AuthContext.jsx";
import { getStats } from "../../../SF";
import "../../../../stats.css";
import QTStatComponent from "../QTStatComponent";
import Loader from "../../../UI/Loader";

function StatsThisQuarter() {
  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(false);
  const context = useAuthContext();

  useEffect(() => {
    if (!context || !context.user) return;
    setLoading(true);
    getStats(context, "This Quarter")
      .then((result) => {
        setData(result);
      })
      .catch(() => {})
      .finally(() => setLoading(false));
  }, [context]);

  if (!context || !context.user) return null;

  const getQuarterName = () => {
    const date = new Date();
    const quarterNames = ["Q1", "Q2", "Q3", "Q4"];
    const quarter = Math.floor(date.getMonth() / 3);
    return quarterNames[quarter];
  };

  const hasStats = data && data.Stats && Object.keys(data.Stats).length > 0;

  return (
    <div>
      {loading && <Loader />}
      {!loading && hasStats && (
        <QTStatComponent stats={data} title={getQuarterName()} />
      )}
      {!loading && !hasStats && <Loader />}
    </div>
  );
}

export default StatsThisQuarter;
